import React from "react";
import { MapPin } from "lucide-react";

const Location = () => {
  const directionsUrl = "https://maps.app.goo.gl/hooxn3Hg2SGoFtcA8";
  // Google Maps embed URL - using coordinates and place name
  const embedUrl = `https://www.google.com/maps?q=33.8572,35.5207&hl=en&z=17&output=embed`;

  return (
    <section id="location" className="py-12 md:py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
            Find Us
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto">
            Visit our office or get directions to our location
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="relative w-full h-[400px] md:h-[500px]">
              <iframe
                src={embedUrl}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Alpha Audit Advisory Location"
              ></iframe>
            </div>

            <div className="p-6 md:p-8 bg-slate-50">
              <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                <div className="flex items-start gap-4">
                  <div className="bg-primary p-3 rounded-lg">
                    <MapPin className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-primary mb-2">
                      Our Office
                    </h3>
                    <p className="text-slate-600 mb-1">
                      Boulevard Center, 3rd Floor
                    </p>
                    <p className="text-slate-600 mb-1">
                      Michel Zakhour, Beirut, Lebanon
                    </p>
                  </div>
                </div>
                <a
                  href={directionsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-primary hover:bg-slate-800 text-white px-6 py-3 rounded-lg font-semibold transition-all flex items-center gap-2 whitespace-nowrap"
                >
                  Get Directions <MapPin size={18} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;
